import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import { GoogleMap, DrawingManager } from '@react-google-maps/api';
import { makeStyles } from '@material-ui/core/styles';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import ReactGA from 'react-ga';

const useStyles = makeStyles((theme) => ({
    right: {
        paddingLeft: "1rem",
    },
    start: {
        
    },
    element: {
        marginBottom: "1rem",
        marginTop: "1rem",

    },
    left: {
        height: "700px",
        width: "100%"
    },
    container: {
        marginLeft: 'auto',
        textAlign: 'center',
        marginRight: 'auto',
        marginTop: "2rem",
        width: "400px",
        maxWidth: "100%"
    }
  }));



const Map = ({active, next, info, state, change}) => {
    const [squareMeters, setSquareMeters] = React.useState();
    const [map, setMap] = React.useState();
    const [drawingManager, setDrawingManager] = React.useState();
    const [polygon, setPolygon] = React.useState();
    const [value, setValue] = React.useState();
    const classes = useStyles();

    const onLoad = (map) => {
        setMap(map);
    }
      
      const onPolygonComplete = polygon => {
        const polyPath = polygon.getPath()
    
        const area = window.google.maps.geometry.spherical.computeArea(polyPath)
        const squareMeters = area.toFixed(0)
        drawingManager.setMap(null);
        const length = Math.sqrt(area)
        const width = length;
        setValue({roofWidth: width, houseLength: length})
        setPolygon(polygon);
        setSquareMeters(squareMeters)
    }
    const reset = () => {
        polygon.setMap(null);
        setPolygon(null);
        drawingManager.setMap(map);
        setSquareMeters(undefined);
    }
    React.useEffect(() => {
      change({...state, geometry: {...state.geometry, ...value}})
      ReactGA.event({
        category: 'Calc',
        action: 'Geometry'
      });
    }, [value])

    const resetAction = (
        <Button color="primary" variant="outlined" size="medium" onClick={reset}>
          Återställ
        </Button>
      );


    return <Grid container component={Paper} elevation={0}>
      <GoogleMap
        mapContainerStyle={{width: "100%", height: "400px"}}
        center={{lat: info.front.location.latitude, lng: info.front.location.longitude}}
        zoom={20}
        onLoad={onLoad}
        options={{
            mapTypeId: "satellite",
            zoomControl: false,
            streetViewControl: false,
            mapTypeControl: false,
            fullscreenControl: false,
        }}
            onUnmount={() => void 0}
      >
          <DrawingManager
            onPolygonComplete={onPolygonComplete}
            drawingMode={'polygon'}
            onLoad={drawingManager => setDrawingManager(drawingManager)}
            options={{
                polygonOptions: {
                    editable: true,
                    draggable: true
                },
                drawingControlOptions: {
                    drawingModes: ['polygon'],
                },
                drawingControl: false,
            }}

    />


      </GoogleMap>
      <Grid item xs={12}>
            {squareMeters && <SnackbarContent
            style={{position: 'relative', top: '-80px', height: 50, width: "400px", maxWidth: "100%", marginLeft: "auto", marginRight: "auto"}}
            message={<Typography style={{display: 'inline-block'}}>Ungefär {(squareMeters/1.7).toFixed(0)} solpaneler.</Typography>}
            action={resetAction}
            />}

      </Grid>
      <Container>
        <Box className={classes.container}>
        <Grid item xs={12}>
                    <Typography variant="h3" className={classes.element} >Markera ditt tak</Typography>
                    <Typography variant="subtitle1"  className={classes.element}>Klicka på hörnen på ditt tak.</Typography>
                    <Button color="primary" disabled={value === undefined} onClick={event => next()} fullWidth size="large" variant="outlined" className={classes.element}>Fortsätt</Button>

        </Grid>
        </Box>

      </Container>

    </Grid>

};

export default Map;